module.exports = __webpack_public_path__ + "static/media/office-lunch-catering-4.3c9331bf.jpg";